import Decimal from "decimal.js";

export function formatBalance(balance: number | string, decimals = 4) {
    const num = new Decimal(balance);
    return num.toDecimalPlaces(decimals).toString();
}

